import { render } from "./DTabungan.vue?vue&type=template&id=1dc01990"
import script from "./DTabungan.vue?vue&type=script&lang=js"
export * from "./DTabungan.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__